/**
 * 报警处理页面
 * 创建时间：2017-03-29
 * 创建人：masonchen
 * 修改人：baixx
 */
<template>
	<div class="float-e-margins ibox-content ibox_main" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label">报警类型</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="dataInfo.almTypeName" readonly>
				</div>
				<label class="col-sm-1 control-label">报警时间</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model="dataInfo.almTime" readonly>
				</div>
				<label class="col-sm-1 control-label">紧急度</label>
				<div class="col-sm-1 pt5px text-center">
					<span v-if="dataInfo.almLevel=='3'"  class="label label-primary label-big">普通提醒</span>
					<span v-if="dataInfo.almLevel=='2'" class="label label-warning label-big">一般报警</span>
					<span v-if="dataInfo.almLevel=='1'" class="label label-danger label-big">紧急报警</span>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">报警说明</label>
				<div class="col-sm-11">
					<textarea class="form-control" rows="3" v-model="dataInfo.almMessage" readonly/>
				</div>
			</div>
			<div class="form-group">
				<!--
                	作者：mudalu@gmail.com
                	时间：2017-06-08
                	描述：处理人暂时删除，待后期修改为文本录入形式
                
				<label class="col-sm-1 control-label">处理人</label>
				<input type="text" :value="data.handleId" style='display:none;'>
				<div class="col-sm-3">
					<select class="form-control" v-model="dataInfo.handleId">
						<option v-for="option in alarmUserList" v-bind:value="option.userId">
							{{ option.name }}
						</option>
					</select>
				</div>
				-->
				<label class="col-sm-1 control-label">处理时间</label>
				<input type="text" :value="data.handleTime" style='display:none;'>
				<div class="col-sm-3">
					<datepicker v-model="dataInfo.handleTime" :value="dataInfo.handleTime" class="form-control" :options="localeOption" :isDisabled="isDetailMode"></datepicker>
					<span class="form-group__message cus_message" v-if="!$v.handleTime.required && $v.handleTime.$error">处理时间为必填项</span>
				</div>
				<!--<label class="col-sm-1 control-label">处理方式</label>
				<div class="col-sm-3">
                    <select class="form-control" v-model="dataInfo.handleType">
					   <option v-for="process in processModeList" :value="process.udcCode">
					   	{{process.udcName}}
					   </option>
					</select>
				</div>-->
			</div>
			<div class="form-group">
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label">处理结果</label>
				<div class="col-sm-6" >
					<textarea type="text" class="form-control" v-model="dataInfo.handleResult" v-bind:readonly="isDetailMode"/>
				</div>
			</div>
			<br />
			<div class="form-group" v-if="isDetailMode">
				<label class="col-sm-1 control-label">录入人</label>
				<div class="col-sm-2">
					<input type="text" class="form-control"  v-model="dataInfo.handleName" readonly>
				</div>
				<label class="col-sm-1 control-label">录入时间</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="dataInfo.inputTime" readonly>
				</div>
				<label class="col-sm-1 control-label">修改人</label>
				<div class="col-sm-2">
					<input type="text" class="form-control"  v-model="dataInfo.updateName" readonly>
				</div>
				<label class="col-sm-1 control-label">修改时间</label>
				<div class="col-sm-2">
					<input type="text" class="form-control" v-model="dataInfo.updateTime" readonly>
				</div>
			</div>
			
			<div class="form-group">
				<div v-if="isDetailMode" class="col-sm-12 text-center">
					<a  class="btn btn-primary white" @click="close">关闭</a>
				</div>
				<div v-else class="col-sm-12 text-center">
					<a v-if="permission.indexOf('alarmHandleList_save') == -1" class="btn btn-primary white" @click="finishedProcessed">保存</a>
					<a v-else class="btn btn-primary white" @click="close">关闭</a>
				</div>
			</div>
		</div>
		<!--SubPage组件弹框开始-->
		<sub-modal ref="modalConfirm" size="small" title="提示">
			{{tipContent}}
			<div slot="footer">
				<button class="btn btn-primary" @click="withdrawSubBtn">取消</button>
				<button class="btn btn-primary" @click="confirmSubBtn">确定</button>
			</div>
		</sub-modal>
		<sub-modal ref="modalMsg" size="small" title="提示">
			{{tipContent}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeMsgTip">确定</button>
			</div>
		</sub-modal>
		<!--SubPage组件弹框结束-->
	</div>	
</template>

<script>
	import { zh } from 'flatpickr/dist/l10n/zh';
    import Datepicker from 'components/common/datepicker/Datepicker'
    import SubModal from 'components/common/SubModal'
    import { SAVE_ENSURE,OPERATE_EXCEPTION } from 'static/message'
    import { required } from 'vuelidate/lib/validators'
    
	export default{
		name: "PageAlarmHandleEdit",
		components: {
			Datepicker,
			SubModal
		},
		props: ['data','isDetailMode'],
		beforeMount() {
//			this.getDrop();
            this.getPer();
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["alarmHandleList"]?this.$store.state.permission.permission["alarmHandleList"]:[],
				loadingstatus:false,
				localeOption: {
			        locale: zh,
			        enableTime: true,
			        enableSeconds: true,
			        time_24hr: true
			    },
//				processModeList:[],
                alarmUserList:[],						//处理人
				tipContent:'',
				dataInfo:this.data,
			};
		},
		validations: {
				handleTime:{
					required
			}
			
		},
		watch: {
		        data(val) {
		            this.dataInfo = val;//新增data的watch，监听变更并同步到dataInfo上
		            //如果时间为空则将当前时间显示在画面中
		            if(val.handleTime=="" && !this.isDetailMode){
		            	let dtCur = new Date();
		            	let yearCur = dtCur.getFullYear();
				        let monCur = dtCur.getMonth() + 1;  
				        let dayCur = dtCur.getDate();  
				        let hCur = dtCur.getHours();  
				        let mCur = dtCur.getMinutes();  
				        let sCur = dtCur.getSeconds();  
				        let timeCur = yearCur + "-" + (monCur < 10 ? "0" + monCur : monCur) + "-"  
				                + (dayCur < 10 ? "0" + dayCur : dayCur) + " " + (hCur < 10 ? "0" + hCur : hCur)  
				                + ":" + (mCur < 10 ? "0" + mCur : mCur) + ":" + (sCur < 10 ? "0" + sCur : sCur);
				        this.dataInfo.handleTime = timeCur;
		            }
		        },
		        dataInfo(val){
		        	this.$emit('input', val);
		        }
		    },
		methods: {
			// 处理完成
			finishedProcessed(){
				this.tipContent = SAVE_ENSURE;	
				this.$refs.modalConfirm.open();
			},
//			getDrop(){
//				this.$http.get(process.env.API_ROOT + '/alarm/alarms/handletypes',{params: {udcTypes: DICTIONARY_MAP.HANDLE_TYPE,customerId:this.$store.state.user.groupid}})
//				.then( res => {
//					if(res.body.success){						
//						this.processModeList = res.body.data;
//					} else {
//					  this.openMsgTip(res.body.message);
//					}
//				}, res => {
//					this.openMsgTip(OPERATE_EXCEPTION);
//				}).catch( res => {
//					this.openMsgTip(OPERATE_EXCEPTION);
//				})
//			},
            //获取处理人列表
			getPer(){
				this.$http.get(process.env.API_ROOT + '/system/users',{params:{customerId: this.$store.state.user.groupid}})
				.then(res => {
					if(res.data.success){
						this.alarmUserList = res.data.data;
					}else{
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message);
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
				})	
			},
			withdrawSubBtn() {
				this.closeSubTip();
			},
			closeSubTip() {
				this.$refs.modalConfirm.close();	
			},
			closeMsgTip() {
				this.$refs.modalMsg.close();	
			},
			openMsgTip(message) {
				this.tipContent = message
				this.$refs.modalMsg.open();	
			},
			close(){
				this.$emit('cancel');
			},
			confirmSubBtn() {
				this.loadingstatus = true;
				this.closeSubTip();
				const para = {
					handleId: this.dataInfo.handleId,		                                // 处理人
					handleResult: this.dataInfo.handleResult,		                        // 处理结果
					handleStatus: '1',						                            // 处理状态
					handleTime: this.dataInfo.handleTime,		                                    // 处理时间
					handleType: this.dataInfo.handleType,		                            // 处理方式
					id: this.dataInfo.id,		                            				// 报警消息ID
				}
				this.$http.put(process.env.API_ROOT + '/alarm/alarms/'+para.id,para)
				.then((response) => {
						if(response.body.success) {
							this.$emit('handleSave',this.dataInfo.almLevel);
						} else {
							this.openMsgTip(response.body.message);
						}
						this.loadingstatus = false;
					}, (response) => {
						this.openMsgTip(response.body.message);
						this.loadingstatus = false;
					})
					.catch((response) => {
						this.openMsgTip(OPERATE_EXCEPTION);
						this.loadingstatus = false;
					})
			},
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// PageAlarmHandleEdit.vue?6a676354